export const errorColor = "E3001B"
export const successColor = '#57D9A3';